export const applicationsTypes = {
  GETTING_APPLICATIONS: 'admin/GETTING_APPLICANTS',
};

export const setApplicants = (history) => ({
  type: applicationsTypes.GETTING_APPLICATIONS,
  history,
});

